
import React, { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import AppointmentCalendar from '@/components/appointment/AppointmentCalendar';

const BadgesSection = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  
  return (
    <section className="content-section columns-section intro-section py-12 bg-white">
      <div className="section-content container mx-auto px-6">
        <div className="content max-w-3xl mx-auto">
          <div className="terms-badges flex flex-wrap gap-2 mb-4 justify-center">
            <Link to="/bilan-patrimonial" className="no-underline">
              <Badge variant="outline" className="px-4 py-1 text-sm rounded-full border-patrimoine-dark text-patrimoine-dark hover:bg-patrimoine-dark hover:text-white transition-colors">
                Bilan patrimonial
              </Badge>
            </Link>
            <Badge 
              className="px-4 py-1 text-sm rounded-full bg-patrimoine-dark text-white hover:bg-patrimoine-muted transition-colors cursor-pointer"
              onClick={() => setIsCalendarOpen(true)}
            >
              Gestion de patrimoine
            </Badge>
          </div>
          
          <h2 className="section-title text-center mt-4 mb-8 max-w-2xl mx-auto">
            L&apos;approche à 360° pour une vision globale : optimiser son patrimoine et sa fiscalité
          </h2>
        </div>
      </div>

      <Dialog open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
        <DialogContent className="sm:max-w-[400px] p-4">
          <DialogHeader className="pb-2">
            <DialogTitle className="text-center font-serif text-base">Prendre Rendez-vous</DialogTitle>
            <DialogDescription className="text-center text-xs">
              Sélectionnez une date et un horaire
            </DialogDescription>
          </DialogHeader>
          <AppointmentCalendar onClose={() => setIsCalendarOpen(false)} />
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default BadgesSection;
